import React from "react";
import ReactLoading from "react-loading";

const Loading = () => {
  return (
    <center><ReactLoading type="bubbles" color="#bbb"/></center>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/Loading.js